// core version + certain modules modules:
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, A11y } from 'swiper/core';

  // configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, A11y]);

const Swipers = {}

    Swipers.logoSlider = new SwiperCore('.logo-slider', {
        autoplay: {
            delay: 0,
        },
        loop: true,
        a11y: true,
        speed: 5000,
        slidesPerView: 3,
        spaceBetween: 28,
        loopFillGroupWithBlank: true,
        breakpoints: {
            992: {
                slidesPerView: 6,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 56,
            },
        }
    });

Swipers.fullWidthSlider = new SwiperCore('.full-width-slider', {
    autoplay: false,
    loop: true,
    a11y: true,
    slidesPerView: 1,
    spaceBetween: 64,
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 1.5,
        },
    }
})
